"use client";

import { useEffect, useState } from "react";
import { ElementProps } from "./ContentElement";
import type { SuccessResult } from "open-graph-scraper/types/lib/types";
import { logError } from "@lib/logger";

export function ContentElementOgp(props: ElementProps) {
  const [ogpInfo, setOgp] = useState<SuccessResult>();
  //OGPデータを表示する
  useEffect(() => {
    const element = props.element;
    if (!element.src) {
      return;
    }

    fetch(`/api/ogp?url=${encodeURIComponent(element.src)}`)
      .then((res) => res.json())
      .then((res) => {
        if (res && !res.error) {
          setOgp(res as SuccessResult);
        }
      })
      .catch((err) => {
        logError("Error fetching OGP data:" + element.src, {});
      });
  }, [props.element.src]);

  if (!props.element.src) {
    return null;
  }
  if (!ogpInfo || !ogpInfo.result) {
    return (
      <p className="g-desc-p">
        <a href={props.element.src} className="g-desc-link">
          {props.element.src}
        </a>
      </p>
    );
  }
  const ogp = ogpInfo.result;

  return (
    <>
      <a
        className="g-desc-embedded-link"
        target="_blank"
        rel="noopener nofollow noindex noreferrer"
        href={props.element.src}
      >
        <div className="g-desc-embedded-link-info">
          <p className="g-desc-embedded-link-title">{ogp.ogTitle}</p>
          {ogpInfo?.result.ogDescription && (
            <p className="g-desc-embedded-link-desc">{ogp.ogDescription}</p>
          )}
          {ogp.ogSiteName && <p className="g-desc-embedded-link-site">{ogp.ogSiteName}</p>}
        </div>
        {ogp.ogImage && (
          <img
            alt={ogp.ogImage[0].alt || ""}
            src={ogp.ogImage[0].url || ""}
            className="g-desc-embedded-link-img"
          />
        )}
      </a>
    </>
  );
}
